import React from "react";

const PlayerEligibilityContext = React.createContext({});

export default PlayerEligibilityContext;
